export default __webpack_public_path__ + "static/media/background-checkin-popup.b204210f.png";